import CreatePossibility from "./CreatePossibility";
export default CreatePossibility;
